import { getYoutubeId } from "./api";
import { resolveMediaUrl } from "./mediaUrl";

export function hasPlayableVideo(video) {
  if (!video) return false;
  if (video.videoFileUrl && resolveMediaUrl(video.videoFileUrl)) return true;
  return Boolean(getYoutubeId(video.youtubeUrl));
}

export function getVideoSourceType(video) {
  if (!video) return null;
  if (video.videoFileUrl) return "upload";
  if (getYoutubeId(video.youtubeUrl)) return "youtube";
  return null;
}
